/*
 * @Author: Ygm
 * @Date: 2023-06-12 10:10:41
 * @LastEditors: Ygm
 * @LastEditTime: 2025-07-17 18:08:46
 * @Description: 文件上传类型
 */
export const UPLOAD_FILE_NUM = 10 // 文件上传数量
export const UPLOAD_FILE_NAME = 100 // 文件上传名长度
export const UPLOAD_FILE_SIZE = 300 * 1024 * 1024 // 文件上传大小
export const PREVIEW_FILE_SIZE = 100 * 1024 * 1024 // 预览文件大小限制 100MB

// 文件上传类型
export const uploadFileType = {
  // 预览文件格式
  preview: [
    '.jpg',
    '.jpeg',
    '.gif',
    '.png',
    '.bmp',
    '.wav',
    '.mp3',
    '.flv',
    '.mp4',
    '.wmv',
    '.pmg',
    '.avi',
    '.rm',
    '.rmvb',
    '.doc',
    '.docx',
    '.ppt',
    '.pptx',
    '.xls',
    '.xlsx',
    '.pdf',
    '.txt'
  ],
  // doc类型
  doc: ['.doc', '.docx'],
  // excel类型
  excel: ['.xls', '.xlsx'],
  // ppt类型
  ppt: ['.ppt', '.pptx'],
  // pdf类型
  pdf: ['.pdf'],
  // txt类型
  txt: ['.txt'],
  // 图片
  image: {
    type: ['.jpg', '.jpeg', '.png', '.gif'],
    size: 1024 * 1024 * 100
  },
  // 视频
  video: {
    type: ['.mp4', '.avi', '.mpeg', '.wmv', '.rmvb', '.rm', '.pmg', '.flv'],
    size: 1024 * 1024 * 100
  },
  // 音频
  audio: {
    type: ['.mp3', '.wma', '.wav', '.bmp', '.acc'],
    size: 1024 * 1024 * 100
  },
  // 文档
  document: {
    type: ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf', '.txt'],
    size: 1024 * 1024 * 100
  },
  // 压缩包
  zip: {
    type: ['.zip', '.rar'],
    size: 1024 * 1024 * 100
  },
  // 其他
  other: {
    type: ['.dbf'],
    size: 1024 * 1024 * 100
  }
}



// WEBPACK FOOTER //
// ./src/view/public/uploadFileType.js